/**
 * 优惠券展示文案。优惠券列表页和用户列表的「赠送优惠券」弹窗都要显示同一批文案，
 * 集中放这里，避免两处各写一份 switch、改一处漏一处。
 *
 * 枚举取值对应后端 CouponEntity（src/entities/coupon/coupon.entity.ts）：
 * type 0满减 1折扣 2随机金额，goodsType 0全部商品 1指定商品 2指定商品不可用。
 */

export function getCouponTypeName(type: any) {
  switch (Number(type)) {
    case 0:
      return "满减券";
    case 1:
      return "折扣券";
    case 2:
      return "随机金额券";
  }
  return "-";
}

/** 优惠内容按类型取不同字段 */
export function getCouponContent(row: any) {
  switch (Number(row?.type)) {
    case 0:
      return `减${row.price}元`;
    case 1:
      return row.hasDiscountLimit
        ? `${row.discount}折，最多优惠${row.discountMaxPrice}元`
        : `${row.discount}折`;
    case 2:
      return `${row.randMinPrice}~${row.randMaxPrice}元`;
  }
  return "-";
}

export function getCouponThreshold(row: any) {
  return row?.hasThreshold ? `满${row.thresholdValue}元可用` : "无门槛";
}

/** 剩余库存 = 发放张数 - 已领取张数，赠送前要据此判断够不够发 */
export function getCouponStock(row: any) {
  return Math.max(Number(row?.count || 0) - Number(row?.consumeCount || 0), 0);
}

/**
 * 用户已领取的券（UserCouponEntity）的优惠内容。
 * 不能直接用 getCouponContent：manager/coupon/user-list 的 select 只取回
 * mainInfo 的 id/name/type/price/discount/hasThreshold/thresholdValue，
 * 没有 randMinPrice / randMaxPrice / discountMaxPrice，随机券会拼出 undefined。
 * 金额改用这张券自己的 price —— 随机券的 price 就是抽中的金额。
 */
export function getUserCouponContent(row: any) {
  let main = row?.mainInfo || {};
  switch (Number(main.type)) {
    case 1:
      return `${main.discount}折`;
    case 0:
    case 2:
      return `减${row?.price}元`;
  }
  return "-";
}

/**
 * 券在用户手上的状态。后端 UserCouponEntity 的 isUse / isExpire 是
 * @Expose({ groups: [USER_SELF] })，manager 侧序列化分组是 MANAGER，取不到，
 * 所以这里按 useTime / startTime / endTime 自己算，口径和 user-list 的 status 筛选一致。
 */
export function getUserCouponStatus(row: any) {
  if (row?.useTime) {
    return { text: "已使用", className: "status-off" };
  }
  let now = Date.now();
  if (row?.endTime && now > new Date(row.endTime).valueOf()) {
    return { text: "已过期", className: "status-off" };
  }
  if (row?.startTime && now < new Date(row.startTime).valueOf()) {
    return { text: "未开始", className: "status-off" };
  }
  return { text: "可用", className: "status-on" };
}

export function getCouponGoodsTypeName(goodsType: any) {
  switch (Number(goodsType)) {
    case 0:
      return "全部商品";
    case 1:
      return "指定商品";
    case 2:
      return "指定商品不可用";
  }
  return "-";
}
